import {Platform} from "@ionic/angular";
import {Component, OnInit} from "@angular/core";
import {Storage} from "@ionic/storage-angular";
import {IonApp, IonRouterOutlet, ModalController} from "@ionic/angular/standalone";
import {NavigationStart, Router} from "@angular/router";
import {App} from "@capacitor/app";
import {Keyboard} from '@capacitor/keyboard';
import {UiServiceService} from "./services/ui.service";
import {PushNotificationService} from "./services/push-notification/push-notification.service";
import {CookieBannerComponent} from "./components/cookie-banner/cookie-banner.component";
import {AnalyticsService} from "./core/legal/analytics.service";
import {ThemeService} from "./core/theme/theme.service";

@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    styleUrls: ["app.component.scss"],
    imports: [IonApp, IonRouterOutlet, CookieBannerComponent],
    providers: [Platform, Router]
})
export class AppComponent implements OnInit {

    constructor(
        private platform: Platform,
        private storage: Storage,
        private router: Router,
        private uiService: UiServiceService,
        private modalController: ModalController,
        private pushNotificationService: PushNotificationService,
        private analyticsService: AnalyticsService,
        // Inyectado solo para que aplique el tema guardado al arrancar.
        private themeService: ThemeService,
    ) {
        this.initializeApp();
        window["navigateInternal"] = this.navigateInternal.bind(this);
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                (document.activeElement as HTMLElement)?.blur();
            }
        });
    }

    async ngOnInit() {
        await this.storage.create();
        this.analyticsService.init();
    }

    initializeApp() {
        this.platform.ready().then(async () => {
            if (this.platform.is('hybrid')) {
                this.platform.backButton.subscribeWithPriority(10, async () => {
                    const topModal = await this.modalController.getTop();
                    if (topModal) {
                        await topModal.dismiss();
                        return;
                    }
                    await this.handleBackButton();
                });

                await Keyboard.addListener('keyboardWillShow', () => {
                    this.uiService.hideFooter();
                });

                await Keyboard.addListener('keyboardWillHide', () => {
                    this.uiService.showFooter();
                });

                await this.pushNotificationService.init();
                this.pushNotificationService.token$.subscribe(t => console.log('[APP] token$ =>', t));
                this.pushNotificationService.message$.subscribe(m => console.log('[APP] message$ =>', JSON.stringify(m)));
                this.pushNotificationService.action$.subscribe(a => console.log('[APP] action$ =>', JSON.stringify(a)));
            }
        });
    }

    private async handleBackButton() {
        if (this.router.url === '/main/home') {
            await App.minimizeApp();
        } else {
            this.uiService.backPage();
        }
    }

    async navigateInternal(path: string) {
        if (path.startsWith("/")) {
            await this.router.navigate([path]);
        } else {
            await this.router.navigate(["/" + path]);
        }
    }
}
